import { MessageData } from '../../../Content';
import React from 'react';

interface MessageContentProps {
  content: MessageData;
}

export const MessageContent: React.FC<MessageContentProps> = ({ content }) => {
  return (
    <div
      style={{
        width: '100%',
        marginBottom: `${(content.aspect ?? 1) * 100}%`,
      }}
    >
      <span>{content.message}</span>
    </div>
  );
};
